export default __webpack_public_path__ + "static/media/storageUnit1-afterC-1920w.d8fc1095.webp";